<div class="flyout-wrapper"
    [class.open]="isOpen()"
    [class.collapsed]="isCollapsed"
    [class.position-left]="isLeftPosition()"
    [class.position-right]="!isLeftPosition()"
    [class.footer-fixed]="shouldPinFooter()"
    [class.expand-horizontal]="isHorizontalExpand()"
    [class.expand-vertical]="!isHorizontalExpand()"
    [class.open-left-to-right]="openDirection() === 'left-to-right'"
    [class.open-right-to-left]="openDirection() === 'right-to-left'"
    [class.open-bottom-to-top]="openDirection() === 'bottom-to-top'"
    [style.width.%]="currentWidth"
    [style.height.%]="currentHeight"
    #flyout>
    <div class="flyout-container">
    <div class="flyout-content">
        <div class="chat-header">
            <div class="header-content">
                <img class="header-logo" src="../../../../assets/Ecolab-Virtual-Agent-Logo.svg" />
                <div class="header-right-controls">
                    @if (showCloseButton()) {
                        <span class="flyout-close" (click)="closeFlyout()">
                            <img class="close-icon" src="../../../../assets/close-darkblue.svg" />
                        </span>
                    }
                    <button class="header-collapse-btn" type="button" aria-label="Collapse EVA panel"
                        (click)="$event.stopPropagation(); toggleFlyout()">
                        <svg class="collapse-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" fill="none">
                            <path d="M37.0417 45.375L37.0417 30.6146L40.7813 34.3437L42.25 32.875L36 26.625L29.75 32.875L31.2188 34.3438L34.9583 30.6146L34.9583 45.375L37.0417 45.375Z" fill="white"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="panel-header-container">

            <!-- border-bottom: 2px solid lightgray;" -->
            <div class="header-sub-container">
                <div>
                    <ng-content select="[panelHeader]"></ng-content>
                </div>
                <div class="panel-toggle-button" (click)="toggleRightPanel()">
                    @if (!showRightPanel) {
                        <img style="transform: rotateY(180deg);" src="../../../../assets/Icon-Navigation.svg" />
                    }
                    <img src="../../../../assets/Icon-Communication.svg" />
                    @if (showRightPanel) {
                        <img src="../../../../assets/Icon-Navigation.svg" />
                    }
                    <span class="panel-toggle-button-text">{{'AI_AGENT.CHAT_HISTORY' | translate}}</span>
                </div>
            </div>
        </div>

        <div class="flyout-body">
            <div class="split-panels-container">
                <!-- Left Panel -->
                <div class="left-panel" [style.width.%]="leftPanelWidth">
                    <div class="panel-content">
                        <div class="left-panel-content">
                            <!-- Left panel content projection -->
                            <ng-content select="[leftPanel]"></ng-content>
                        </div>
                    </div>
                </div>

                <!-- Right Panel -->
                @if (showRightPanel) {
                    <div class="right-panel" [style.width.%]="rightPanelWidth">
                        <div class="panel-content">
                            <div class="right-panel-header">
                                <img src="../../../../assets/Icon-Communication-blue.svg" />
                                <span class="ms-2 chat-history">{{'AI_AGENT.CHAT_HISTORY' | translate}}</span>
                            </div>
                            <div class="right-panel-content">
                                <!-- Right panel content projection -->
                                <ng-content select="[rightPanel]" style="height: 100%;"></ng-content>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
        <div class="flyout-footer">
            <div class="panel-footer-container">
                <!-- Left Panel -->
                <div class="footer-panel">
                    <div class="panel-content">
                        <!-- Left panel content projection -->
                        <ng-content select="[panelFooter]"></ng-content>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>

    <div class="resize-handle" #resizeHandle (mousedown)="startResize($event)">
        @if (isHorizontalExpand()) {
            <svg class="resize-indicator-svg"
                [class.mirrored]="!isLeftPosition()"
                viewBox="0 0 21 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <g filter="url(#resize-shadow)">
                    <path d="M4 6C4 3.79086 5.79086 2 8 2H17V44H8C5.79086 44 4 42.2091 4 40V6Z" fill="#D9E9F8" shape-rendering="crispEdges"/>
                    <svg x="6.75" y="20.27" width="7.5" height="5.45455" viewBox="0 0 7.5 5.45455" fill="none" overflow="visible">
                        <path d="M7.5 2.72727L4.77955 0V2.04545H0V3.40909H4.77955V5.45455L7.5 2.72727Z" fill="#006BD3"/>
                    </svg>
                </g>
                <defs>
                    <filter id="resize-shadow" x="0" y="0" width="21" height="50" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="2"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                    </filter>
                </defs>
            </svg>
        } @else {
            <div class="resize-indicator"></div>
        }
    </div>
</div>